import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puedo hacer SAINT® sin tomar antidepresivos?",
    answer:
      "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La decisión de continuar, suspender o iniciar medicación se toma con el psiquiatra. SAINT® no requiere estar tomando antidepresivos en el momento del tratamiento.",
  },
  {
    question: "¿SAINT® sustituye a la medicación?",
    answer:
      "SAINT® no sustituye necesariamente a la medicación. La decisión sobre la medicación se toma con el psiquiatra en función de las circunstancias individuales.",
  },
];

export const esWithoutMedication = makeEsArticle({
  slug: "depression-treatment-without-medication",
  title: "Tratamiento de la depresión sin medicación: SAINT®",
  description:
    "SAINT® es una opción de tratamiento para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No requiere estar tomando antidepresivos en el momento del tratamiento.",
  h1: "Tratamiento de la depresión sin medicación",
  breadcrumbLabel: "Tratamiento sin medicación",
  shortAnswer:
    "SAINT® es una opción de tratamiento para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® no requiere estar tomando antidepresivos en el momento del tratamiento. La decisión de continuar, suspender o iniciar medicación se toma con el psiquiatra. SAINT® no sustituye necesariamente a la medicación.",
  keyTakeaways: [
    "SAINT® es una opción para el trastorno depresivo mayor.",
    "Está indicado para adultos que no han mejorado con antidepresivos.",
    "No requiere estar tomando antidepresivos en el momento del tratamiento.",
    "La decisión sobre la medicación se toma con el psiquiatra.",
    "SAINT® no sustituye necesariamente a la medicación.",
  ],
  sections: [
    {
      heading: "SAINT® y la medicación",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. Esto significa que la indicación es para personas que ya han probado antidepresivos sin suficiente alivio, pero no requiere estar tomando antidepresivos en el momento del tratamiento.",
      ],
    },
    {
      heading: "Decisiones sobre la medicación",
      paragraphs: [
        "La decisión de continuar, suspender o iniciar medicación se toma con el psiquiatra en función de las circunstancias individuales. SAINT® no sustituye necesariamente a la medicación.",
      ],
    },
    {
      heading: "Si los antidepresivos no han funcionado",
      paragraphs: [
        "Si ha probado antidepresivos sin suficiente alivio, SAINT® puede ser una opción a considerar. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
